export default __webpack_public_path__ + "assets/left_mobile.ed885859.png";